"use client"

import Image from "next/image"
import { cn } from "@local/utils/src/cn"
// import { getShippingThreshold } from "@local/cart/src/shipping"
import { getCdnUrl } from "@local/utils/src/getCdnUrl"
import { roboto } from "../../../utils/fonts"
import type { ContentIconsSingleIconProps } from "./ContentIconsSingleIcon"

export const ContentIconsSingleIconJustified = ({
  icon,
  className,
  market,
}: {
  icon: ContentIconsSingleIconProps
  className?: string
  market: string
}) => {
  let currencySymbol: string

  switch (market) {
    case "eu":
      currencySymbol = "€"
      break
    case "ch":
      currencySymbol = "CHF"
      break
    case "au":
      currencySymbol = "AU$"
      break
    case "nz":
      currencySymbol = "NZ$"
      break
    case "ca":
      currencySymbol = "CA$"
      break
    case "gb":
      currencySymbol = "£"
      break
    default:
      currencySymbol = "$"
      break
  }

  const FREE_SHIPPING_THRESHOLD = 10 //getShippingThreshold(currencyCode)

  const heading = icon.heading
    .replace("%%CURRENCY%%", `${currencySymbol}\u2060`)
    .replace(
      "%%SHIPPING%%",
      Math.round(FREE_SHIPPING_THRESHOLD / 100).toString()
    )
  const text = icon.text
    .replace("%%CURRENCY%%", `${currencySymbol}\u2060`)
    .replace(
      "%%SHIPPING%%",
      Math.round(FREE_SHIPPING_THRESHOLD / 100).toString()
    )

  return (
    <div
      className={cn(
        "flex min-w-[95%] flex-col items-start justify-start align-middle",
        className
      )}
    >
      {icon.image?.url ? (
        <div className="flex w-4/5 items-start" aria-hidden="true">
          <Image
            src={getCdnUrl({ src: icon.image?.url || "", width: 40 })}
            alt={icon.heading}
            role="presentation"
            width={40}
            height={40}
            className="mb-2 max-w-[120px]"
          />
        </div>
      ) : null}
      <h5 className="text-h5 leading-heading my-2 font-semibold uppercase">
        {heading}
      </h5>
      <p className={`${roboto.className} text-base leading-5 font-normal`}>
        {text}
      </p>
    </div>
  )
}
